var gl = {}

export default gl
